import { useLastLoadable} from 'ccstate-react'
import { allArticles$ } from '../../../../frontend/externalState'
import Layout from '../components/Layout'

export default function Home() {
  const allArticles = useLastLoadable(allArticles$)
  if (allArticles.state === 'loading') {
    return <div>loading...</div>
  } else if (allArticles.state === 'hasData') {
    return (
      <Layout>
        {allArticles.data.map(article => {
          return <div key={article.id}>{article.title}</div>
        })}
        <button
          onClick={() => {
            throw new Error('This is your first error!')
          }}
        >
      Test sentry integration</button>
      </Layout>
    )
  } else if (allArticles) {
    return <div>load failed: {String(allArticles.error)}</div>
  }
}
